import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaibushirefortour() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Bus Hire for Tour Package From Pune',
    heading: 'Sanavi Travels: Pune to Mumbai Bus Hire for Tour Package From Pune',
    headingDescription: 'Sanavi Travels offers reliable Pune to Mumbai Bus Hire for Tour Package from Pune, providing safe, comfortable, and hassle-free transportation for families, corporate groups, tourists, and educational tours planning a memorable Mumbai trip from Pune. Our fleet of AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, is well-maintained with spacious seating, ample legroom, and sufficient luggage space to ensure a smooth and enjoyable journey. With experienced long-route drivers, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a punctual and comfortable travel experience. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Mumbai destinations such as Gateway of India, Marine Drive, Juhu Beach, EsselWorld, Sanjay Gandhi National Park, and Bollywood tours. Choose Sanavi Travels for trusted Pune to Mumbai bus hire for tour packages, delivering comfort, safety, and a seamless group travel experience.',

    top: 'Top Places to Visit in Mumbai with Sanavi Travels',


"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it features grand Indo-Saracenic architecture. The site is a popular gathering spot for tourists and locals alike, offering boat rides to nearby attractions. It symbolizes Mumbai’s historical and cultural significance."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6-kilometer-long promenade along Mumbai’s coastline. Famous for its stunning sunsets and city skyline, it is ideal for evening strolls, jogging, and photography. The curved road lights up at night, resembling a string of pearls. Marine Drive represents Mumbai’s urban charm and seaside beauty."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887, it showcases Victorian Gothic architecture with intricate domes, turrets, and stained glass windows. The station is both a functional transport hub and a historical landmark. CSMT highlights Mumbai’s architectural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green oasis within Mumbai city, covering over 104 square kilometers. It houses ancient Kanheri Caves, diverse wildlife, and trekking trails. Visitors can enjoy boating, nature walks, and safaris. The park provides a serene escape from the bustling city and showcases Mumbai’s natural heritage."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are a UNESCO World Heritage Site known for their rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves feature intricate carvings, massive pillars, and large sculpted panels. Accessible by ferry, it is a must-visit historical and spiritual site near Mumbai."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque and tomb situated on a small islet off the coast of Mumbai. Built in 1431, it is accessible via a narrow causeway during low tide. The mosque is a pilgrimage site for devotees from all faiths and is known for its stunning architecture and spiritual ambiance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, famous for its street food, local snacks, and evening crowd. Visitors enjoy walking along the coastline, watching sunsets, and engaging in recreational activities. The beach reflects Mumbai’s vibrant lifestyle and coastal charm."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, one of Mumbai’s oldest markets, is famous for antiques, vintage items, furniture, and quirky collectibles. Bargaining is part of the experience, making it a treasure hunt for locals and tourists. The market reflects Mumbai’s rich trade history and bustling commercial culture."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling shopping street in South Mumbai, known for fashion boutiques, handicrafts, and street vendors. It is also home to cafes, restaurants, and art galleries. The area is lively and a must-visit for shopping and experiencing Mumbai’s cosmopolitan vibe."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a famous Hindu temple dedicated to Lord Ganesha, located in Prabhadevi, Mumbai. Devotees from across the country visit to seek blessings, especially on Tuesdays. The temple features beautiful architecture and a spiritual atmosphere, making it one of Mumbai’s most important religious landmarks."
  }
]
,




"services": [
  {
    "name": "Pune to Mumbai Bus Hire for Tour Package From Pune",
    "description": "Pune to Mumbai Bus Hire for Tour Package From Pune provides comfortable and reliable buses for groups traveling from Pune to Mumbai. Ideal for family trips, corporate outings, or group tours, these buses feature spacious seating, luggage space, and professional drivers ensuring a safe and smooth journey. Flexible booking options and well-maintained vehicles make long-distance travel convenient and stress-free."
  },
  {
    "name": "Mumbai Tour Bus from Pune",
    "description": "Mumbai Tour Bus from Pune offers private and group rental services for sightseeing and travel within Mumbai. Equipped with comfortable seating, air-conditioning, and safety features, these buses are perfect for families, friends, or corporate groups. Experienced drivers ensure timely arrivals and a hassle-free journey for all travelers."
  },
  {
    "name": "AC Bus Pune to Mumbai",
    "description": "AC Bus Pune to Mumbai provides air-conditioned vehicles for a cool and comfortable long-distance journey. Ideal for family trips, corporate travel, or group tours, these buses offer spacious interiors, ample luggage space, and professional chauffeurs ensuring safety and smooth travel along highways and city roads."
  },
  {
    "name": "Luxury Mumbai Tour Bus",
    "description": "Luxury Mumbai Tour Bus offers premium vehicles for a stylish and comfortable travel experience. Equipped with reclining seats, entertainment options, and ample luggage space, these luxury buses cater to VIP groups, corporate outings, or family trips seeking elegance and convenience during their journey."
  },
  {
    "name": "Family Mumbai Bus Trip",
    "description": "Family Mumbai Bus Trip ensures safe and comfortable travel for families visiting Mumbai. With spacious seating, luggage space, and child-friendly features, this service prioritizes comfort and convenience, making weekend trips or longer journeys stress-free and enjoyable."
  },
  {
    "name": "Group Travel Mumbai Bus",
    "description": "Group Travel Mumbai Bus is ideal for friends, office groups, or tour operators traveling together. Spacious vehicles, professional drivers, and organized pick-up/drop-off arrangements make group travel safe, comfortable, and convenient for all passengers."
  },
  {
    "name": "Affordable Mumbai Bus Package",
    "description": "Affordable Mumbai Bus Package provides budget-friendly rental options for groups or families traveling to Mumbai without compromising on comfort or safety. Well-maintained vehicles and skilled drivers ensure a smooth and reliable journey at economical rates."
  },
  {
    "name": "Chauffeur Driven Mumbai Bus",
    "description": "Chauffeur Driven Mumbai Bus provides professional drivers to handle all routes, traffic, and navigation, allowing passengers to relax throughout the journey. Safe, reliable, and comfortable, this service is perfect for families, friends, or corporate travelers."
  },
  {
    "name": "Best Mumbai Tour Bus Pune",
    "description": "Best Mumbai Tour Bus Pune offers top-quality vehicles and professional services for a superior travel experience. Comfortable interiors, experienced drivers, and attention to passenger convenience ensure a smooth, safe, and enjoyable trip for families, friends, and corporate groups."
  },
  {
    "name": "Pune Mumbai Travel Bus",
    "description": "Pune Mumbai Travel Bus provides dependable and comfortable transport for groups traveling from Pune to Mumbai. Spacious interiors, luggage-friendly seating, and professional drivers ensure smooth and safe journeys for tourists, corporate travelers, and family trips."
  },
  {
    "name": "Tourist Bus Hire Mumbai",
    "description": "Tourist Bus Hire Mumbai offers vehicles for sightseeing and leisure travel within Mumbai. With ample seating, luggage space, and experienced drivers, this service ensures tourists enjoy their trip comfortably and conveniently."
  },
  {
    "name": "One Day Trip Bus Mumbai",
    "description": "One Day Trip Bus Mumbai provides vehicles for short excursions or day tours from Pune to Mumbai. Ideal for sightseeing, corporate events, or family outings, these buses offer comfort, ample space, and reliable service for a hassle-free day trip."
  },
  {
    "name": "Weekend Tour Bus Mumbai",
    "description": "Weekend Tour Bus Mumbai is perfect for short getaways and weekend travel. Comfortable, spacious, and reliable, these buses make it easy for families, friends, or corporate groups to enjoy a relaxed trip without travel-related stress."
  },
  {
    "name": "Holiday Bus Package Mumbai",
    "description": "Holiday Bus Package Mumbai provides complete travel solutions for tourists and families planning trips to Mumbai. Well-maintained vehicles, experienced drivers, and spacious interiors ensure a safe, convenient, and enjoyable holiday experience."
  },
  {
    "name": "Mumbai Sightseeing Bus Pune",
    "description": "Mumbai Sightseeing Bus Pune offers guided sightseeing trips from Pune to Mumbai. Comfortable and spacious buses with professional drivers provide hassle-free travel, making it ideal for families, friends, and tourist groups exploring Mumbai's attractions."
  }
],
"tableData": [
  ["Pune to Mumbai Bus Hire for Tour Package From Pune", "Mumbai Tour Bus from Pune"],
  ["AC Bus Pune to Mumbai", "Luxury Mumbai Tour Bus"],
  ["Family Mumbai Bus Trip", "Group Travel Mumbai Bus"],
  ["Affordable Mumbai Bus Package", "Chauffeur Driven Mumbai Bus"],
  ["Best Mumbai Tour Bus Pune", "Pune Mumbai Travel Bus"],
  ["Tourist Bus Hire Mumbai", "One Day Trip Bus Mumbai"],
  ["Weekend Tour Bus Mumbai", "Holiday Bus Package Mumbai"],
  ["Mumbai Sightseeing Bus Pune", "—"]
]

,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Bus Hire for Tour Package From Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and well-organized bus hire tour packages from Pune to Mumbai, ideal for group tours, family trips, corporate outings, and city explorations."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses with ample seating and storage space for a smooth journey from Pune to Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune–Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune–Mumbai highways, ensuring safe, punctual, and hassle-free travel throughout your tour."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Mumbai bus hire tour packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages",
    "WhyChoosedescription": "Choose from one-day, weekend, or customized Pune to Mumbai bus tour packages tailored to your group’s preferences and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Mumbai bus hire tour packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Mumbai bus hire tour packages?',
    answer: 'Yes, Sanavi Travels provides well-organized and comfortable bus hire tour packages from Pune to Mumbai.'
  },
  {
    question: 'How can I book a Pune to Mumbai bus tour package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Pune to Mumbai tour?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for group travel and city tours.'
  },
  {
    question: 'Are drivers included in the Pune to Mumbai bus hire package?',
    answer: 'Yes, all tour packages include experienced and professional drivers familiar with the Pune–Mumbai route.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Mumbai bus tour package?',
    answer: 'Absolutely. Sanavi Travels offers customized tour packages according to your travel needs and preferences.'
  },
  {
    question: 'What payment options are available for the bus tour package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Mumbai tour.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshmukh',
    feedback: 'Booked a Pune to Mumbai bus tour package with Sanavi Travels. Comfortable bus, excellent service, and smooth journey throughout!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience! Clean bus, punctual pickup, and knowledgeable driver made our Mumbai tour memorable.',
    rating: 5
  }
];





































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Bus Hire for Tour Package From Pune - Sanavi Travels",
  "description": "Book Pune to Mumbai bus hire for tour packages with Sanavi Travels. AC and luxury buses for Mumbai sightseeing, family holidays, group travel, one-day trips, weekend tours, and comfortable chauffeur-driven travel services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Mumbai Bus Hire for Tour Package From Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses from Pune to Mumbai with Sanavi Travels. Perfect for Mumbai sightseeing, family holidays, group tours, one-day trips, weekend tours, and customized travel packages."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaibushirefortour;